<template>
  <keep-alive include="report">
    <router-view :key="$route.fullPath" />
  </keep-alive>
</template>

<script>

export default {

}
</script>

<style>

</style>
